

































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import CoinsIcon from '@/components/icons/Coins.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    Typography,
    Surface,
    TextField,
    CoinsIcon,
    FormHeader
  }
})
export default class OfferFreeCoinsCoinSettings extends Vue {
  @Prop({ default: '' }) readonly value!: string;
  @Prop() readonly error!: any[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get coinValue() {
    return 1;
  }

  get businessCurrencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  openCoinsModal() {
    this.$emit('coins-modal-opened');

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'offerFreeCoinsInstructionsModal',
        false,
        true,
        true,
        true,
        true
      ),
      { coinValue: this.coinValue }
    );

    this.$analytics({
      eventCategory:
        'Free Coins Campaign Creation | How many Coins should I give? link',
      eventAction: 'click',
      eventLabel: 'Opened modal'
    });
  }

  mounted() {
    if (this.isMobileDevice) return;

    const freeCoin = this.$refs.freeCoin as any;
    freeCoin.$refs.input.focus();
  }
}
